import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const PendingApproval = () => {
    // Reached from three flows: right after registering (default copy), a
    // login attempt on a not-yet-verified account (state.from === 'login'),
    // or a login on a rejected account (state.rejected, with the staff
    // reason in state.note — no self-serve resubmit, users contact support).
    const location = useLocation();
    const fromLogin = location.state?.from === 'login';
    const rejected = Boolean(location.state?.rejected);
    const note = location.state?.note || '';
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md text-center">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <h2 className="text-2xl font-bold mb-4">
                        {rejected
                            ? 'Verification Rejected'
                            : fromLogin ? 'Account Awaiting Verification' : 'Registration Submitted Successfully!'}
                    </h2>
                    {rejected ? (
                        <>
                            <p className="text-gray-600 mb-2">
                                Your account could not be verified.
                            </p>
                            {note && (
                                <p className="text-red-600 font-medium mb-2">
                                    Reason: {note}
                                </p>
                            )}
                            <p className="text-gray-600 mb-6">
                                Sign in to the WholesaleDai mobile app to upload replacement
                                documents, or contact support for assistance.
                            </p>
                        </>
                    ) : (
                    <p className="text-gray-600 mb-6">
                        Your account is pending administrator approval.
                        You'll receive an email notification once your account is activated.
                    </p>
                    )}
                    <Link
                        to="/login"
                        className="text-brand-600 hover:text-brand-700 font-medium"
                    >
                        Back to Login
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PendingApproval;